import SelectionBar from "./SelectionBar.vue";

export default SelectionBar;
